import React, { useEffect, useState } from 'react';
import './online-users.css';
import { getCurrentUserOrLogoutRedirect } from '../../auth';
import '../user/user.css';
import { getUser } from '../../services/user';
import { useParams } from 'react-router-dom';
import CurrentUserAvatar from '../user/CurrentUserAvatar';
import { EditorService, IChannelConnections } from '../../services/editor';
import { Tooltip } from '@mui/material';
import { IUser, IWSSessionChannelSubscription } from '@elyx-code/definitions';
import { Logger } from '@elyx-code/common-ts-utils';

interface IOnlineUsersProps {
	currentUser?: IUser;
	// onlineUsers?: IUser[];
	project: EditorService;
}

// const shortListOfFakeOnlineUsers: IUser[] = [
// 	{
// 		id: '7af16ca3-3da4-4c1a-b75f-6ab9d23e5d35',
// 		picture: 'https://i.pravatar.cc/150?img=68',
// 		name: 'John',
// 		lastName: 'Doe',
// 		email: 'john.doe@example.com',
// 		identityProviderUserId: '7af16ca3-3da4-4c1a-b75f-6ab9d23e5d35',
// 		identityProvider: IdentityProvider.COGNITO,
// 		createdAt: '2023-10-01T12:00:00Z',
// 		updatedAt: '2023-10-01T12:00:00Z',
// 	},
// 	{
// 		id: 'b5fe6434-d7e9-4c99-86c3-542800e65a64',
// 		picture: undefined,
// 		name: 'Carlos',
// 		lastName: 'Osman',
// 		email: 'carlos.osman@example.com',
// 		identityProviderUserId: 'b5fe6434-d7e9-4c99-86c3-542800e65a64',
// 		identityProvider: IdentityProvider.COGNITO,
// 		createdAt: '2023-10-01T12:00:00Z',
// 		updatedAt: '2023-10-01T12:00:00Z',
// 	},
// 	{
// 		id: 'e9fda7ad-0f05-4ed1-b746-5f1aa723825f',
// 		picture: 'https://i.pravatar.cc/150?img=5',
// 		name: 'Chloe',
// 		lastName: 'Smith',
// 		email: 'chloe.smith@example.com',
// 		identityProviderUserId: 'e9fda7ad-0f05-4ed1-b746-5f1aa723825f',
// 		identityProvider: IdentityProvider.COGNITO,
// 		createdAt: '2023-10-01T12:00:00Z',
// 		updatedAt: '2023-10-01T12:00:00Z',
// 	},
// 	{
// 		id: '25c378d5-8cf6-4915-8d58-3ecbb6b2d2ff',
// 		picture: 'https://i.pravatar.cc/150?img=10',
// 		name: 'Chloe',
// 		lastName: 'Smith',
// 		email: 'chloe.smith@example.com',
// 		identityProviderUserId: '25c378d5-8cf6-4915-8d58-3ecbb6b2d2ff',
// 		identityProvider: IdentityProvider.COGNITO,
// 		createdAt: '2023-10-01T12:00:00Z',
// 		updatedAt: '2023-10-01T12:00:00Z',
// 	},
// ];

// const longListOfFakeOnlineUsers: IUser[] = [
// 	...shortListOfFakeOnlineUsers,
// 	{
// 		id: '99c6682f-bcf3-4131-a50e-003837d66db8',
// 		picture: 'https://i.pravatar.cc/150?img=6',
// 		name: 'Tina',
// 		lastName: 'Turner',
// 		email: 'tina.turner@example.com',
// 		identityProviderUserId: '99c6682f-bcf3-4131-a50e-003837d66db8',
// 		identityProvider: IdentityProvider.COGNITO,
// 		createdAt: '2023-10-01T12:00:00Z',
// 		updatedAt: '2023-10-01T12:00:00Z',
// 	},
// 	{
// 		id: 'e792aeca-bd81-454e-b5bc-7d36b011df6b',
// 		picture: 'https://i.pravatar.cc/150?img=18',
// 		name: 'Joseph',
// 		lastName: 'Maxwell',
// 		email: 'joseph.maxwell@example.com',
// 		identityProviderUserId: 'e792aeca-bd81-454e-b5bc-7d36b011df6b',
// 		identityProvider: IdentityProvider.COGNITO,
// 		createdAt: '2023-10-01T12:00:00Z',
// 		updatedAt: '2023-10-01T12:00:00Z',
// 	},
// 	{
// 		id: 'c870b487-6028-4159-9a8c-4d5c16cd0cb1',
// 		picture: 'https://i.pravatar.cc/150?img=21',
// 		name: 'Susan',
// 		lastName: 'Harper',
// 		email: 'susan.harper@example.com',
// 		identityProviderUserId: 'c870b487-6028-4159-9a8c-4d5c16cd0cb1',
// 		identityProvider: IdentityProvider.COGNITO,
// 		createdAt: '2023-10-01T12:00:00Z',
// 		updatedAt: '2023-10-01T12:00:00Z',
// 	},
// 	{
// 		id: 'c4cb5a8c-7e04-4bbc-90e9-c9f660878ddc',
// 		picture: 'https://i.pravatar.cc/150?img=50',
// 		name: 'Annie',
// 		lastName: 'Miracle',
// 		email: 'annie.miracle@example.com',
// 		identityProviderUserId: 'c4cb5a8c-7e04-4bbc-90e9-c9f660878ddc',
// 		identityProvider: IdentityProvider.COGNITO,
// 		createdAt: '2023-10-01T12:00:00Z',
// 		updatedAt: '2023-10-01T12:00:00Z',
// 	},
// ];

const maxAmountOfDisplayableUsers = 5;

const PageOnlineUsers: React.FC<IOnlineUsersProps> = ({
	// onlineUsers = [],
	project
}) => {
	const [currentUser, setCurrentUser] = useState<
		(IUser & { sessionId: string }) | null
	>(null);
	const [onlineUsers, setOnlineUsers] = useState<
		(IUser & { sessionId: string })[]
	>([]);
	const { id: projectId } = useParams<{ id: string }>();

	const events = project?.events;

	const initialProjectPeerConnectionsToUsers = async () => {
		if (!project) {
			return;
		}

		const peerConnections = project?.peerConnections;
		const canvasChannel =
			peerConnections[project?.PROJECT_NOTIFICATIONS_CHANNEL];

		const updatedOnlineUsers: (IUser & { sessionId: string })[] = (
			await Promise.all(
				(canvasChannel?.connections || []).map(
					async (
						user: Omit<IWSSessionChannelSubscription, 'channel'>
					) => {
						// Fetch the user data from the server
						const userData = await getUser({ id: user.userId });

						if (userData) {
							return {
								...userData,
								online: user.connectionId !== null,
								sessionId: user.sessionId
							};
						}

						return null;
					}
				)
			)
		).filter(
			(user: IUser | null): user is IUser & { sessionId: string } =>
				user !== null
		);

		Logger.log('updated initial online users', updatedOnlineUsers);

		setOnlineUsers(updatedOnlineUsers);
	};

	useEffect(() => {
		const fetchCurrentUser = async () => {
			try {
				const user = await getCurrentUserOrLogoutRedirect();
				setCurrentUser(user);
			} catch (e) {
				Logger.log('Error getting user profile', e);
			}
		};

		fetchCurrentUser();
	}, []);

	useEffect(() => {
		Logger.log('Subscribing to peer connections updates');

		initialProjectPeerConnectionsToUsers();

		const handleMessage = async (
			message: Record<string, IChannelConnections>
		) => {
			Logger.log('message recieved at online users', message);

			const canvasChannel =
				message[project.PROJECT_NOTIFICATIONS_CHANNEL];

			if (!canvasChannel) {
				return;
			}

			const updatedOnlineUsers: (IUser & { sessionId: string })[] = (
				await Promise.all(
					canvasChannel.connections.map(
						async (
							user: Omit<IWSSessionChannelSubscription, 'channel'>
						) => {
							// Fetch the user data from the server
							const userData = await getUser({ id: user.userId });

							if (userData) {
								return {
									...userData,
									online: user.connectionId !== null,
									sessionId: user.sessionId
								};
							}

							return null;
						}
					)
				)
			).filter(
				(user: IUser | null): user is IUser & { sessionId: string } =>
					user !== null
			);

			Logger.log('updated online users', updatedOnlineUsers);

			setOnlineUsers(updatedOnlineUsers);
		};

		events?.on('peer-connections-updated', handleMessage);
		return () => {
			// unsubscribe the same callback
			events?.off('peer-connections-updated', handleMessage);
		};
	}, [events, project?.PROJECT_NOTIFICATIONS_CHANNEL]);

	// Filter out the active tab's session connection and deduplicate other active sessions by sessionId
	let removedCurrentSession = false;
	const otherOnlineUsers = onlineUsers.filter((user) => {
		if (user.sessionId === project.sessionId && !removedCurrentSession) {
			removedCurrentSession = true;
			return false;
		}
		return true;
	});

	const uniqueUsers: (IUser & { sessionId: string })[] = [];
	const seenSessionIds = new Set<string>();
	for (const user of otherOnlineUsers) {
		const key = user.sessionId || user.id;
		if (!seenSessionIds.has(key)) {
			seenSessionIds.add(key);
			uniqueUsers.push(user);
		}
	}

	const remainingOnlineUsers =
		uniqueUsers.length - maxAmountOfDisplayableUsers;
	const shortenedOnlineUsers = uniqueUsers.slice(
		0,
		maxAmountOfDisplayableUsers
	);

	return (
		<div className="online-users">
			<div className="online-users__other-users">
				{remainingOnlineUsers > 0 && (
					<div className="online-users__other-users-helper-text">
						<p>+ {remainingOnlineUsers}</p>
						{/* <p>{remainingOnlineUsers > 1 ? 'others' : 'other'}</p> */}
					</div>
				)}
				{shortenedOnlineUsers.map((user, index) => {
					const thereIsName = !!user.name || !!user.lastName;
					return (
						<Tooltip
							key={user.id + '--' + user.sessionId}
							title={
								thereIsName
									? `${user.name} ${user.lastName}`
									: ''
							}
							placement="bottom"
							arrow
						>
							<div
								key={user.id}
								className={`user-avatar ${
									// Random boolean to simulate online status
									// @ts-ignore
									user.online ? 'user-avatar-online' : ''
								}`}
							>
								{user.picture ? (
									<img
										src={user.picture}
										alt={`Profile picture of ${user.name} ${user.lastName}`}
										title={
											thereIsName
												? `${user.name} ${user.lastName}`
												: ''
										}
									/>
								) : (
									<i
										className="fa-solid fa-user"
										title={
											thereIsName
												? `${user.name} ${user.lastName}`
												: ''
										}
										style={{ fontSize: '14px' }}
									/>
								)}
							</div>
						</Tooltip>
					);
				})}
			</div>
			<div className="online-users__current-user">
				<CurrentUserAvatar
					profilePagePath={`${project?.editorBasePath}/profile/{id}`}
				/>
			</div>
		</div>
	);
};

export default PageOnlineUsers;
